class LocalStorageAdapter {
  static getItem = <T>(key: string): T | null => {
    const item = localStorage.getItem(key);

    return item ? JSON.parse(item) : null;
  };

  static setItem = <T>(key: string, value: T) => {
    localStorage.setItem(key, JSON.stringify(value));
  };

  static removeItem = (key: string) => {
    localStorage.removeItem(key);
  };

  static clear = () => {
    localStorage.clear();
  };
}

export default LocalStorageAdapter;
